import { Avatar, Button, Switch } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../Assets/logo1.png";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import { MdOutlineZoomOutMap } from "react-icons/md";
import { baseURL } from "../../Config/axios";

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verification, setVerification] = useState(false);

  const email = localStorage.getItem("email");
  const user_name = localStorage.getItem("user_name");

  /* ---------------- FULLSCREEN ---------------- */
  const handleFullscreenToggle = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
    setIsFullscreen(!isFullscreen);
  };

  useEffect(() => {
    const handler = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", handler);
    return () => document.removeEventListener("fullscreenchange", handler);
  }, []);

  /* ---------------- LOGOUT ---------------- */
  const handleLogoutReseller = () => {
    axios
      .post(
        `https://m1blog.aaragroups.com/blog/blog-store-logout/`,
        { email },
        { headers: { Token: localStorage.getItem("token") } },
      )
      .then(() => {
        localStorage.clear();
        navigate("/");
      })
      .catch(() => toast.error("Logout failed"));
  };

  /* ---------------- TWO STEP ---------------- */
  useEffect(() => {
    const storedValue = localStorage.getItem("two_step_verification");
    setVerification(storedValue === "true");
  }, []);

  const handleChange = () => {
    setLoading(true);
    axios
      .post(
        `${baseURL}/blog/active-deactive-two-factor-auth-verification/`,
        {},
        { headers: { Token: localStorage.getItem("token") } },
      )
      .then((res) => {
        if (res?.data?.response_code === 200) {
          const value = res.data.two_step_verification;
          setVerification(value);
          localStorage.setItem("two_step_verification", value.toString());
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <header className="w-full bg-white rounded-lg shadow px-3 py-2">
      <div className="flex items-center justify-between gap-2">
        {/* LEFT */}
        <div className="flex items-center gap-2">
          <IconButton onClick={toggleSidebar}>
            <MenuIcon />
          </IconButton>
          <p className="text-lg md:text-xl font-bold whitespace-nowrap">
            Blog Admin
          </p>
        </div>

        {/* RIGHT */}
        <div className="flex items-center gap-2 md:gap-4">
          {/* Fullscreen (hidden on mobile) */}
          <MdOutlineZoomOutMap
            onClick={handleFullscreenToggle}
            className="hidden md:block text-4xl p-2 rounded-lg bg-gray-100 cursor-pointer hover:text-gray-500"
          />

          {/* Two Step Toggle */}
          <div className="hidden sm:flex flex-col text-xs">
            <div className="flex items-center gap-1">
              <span className="whitespace-nowrap">Two-Step Verification</span>
              <Switch
                size="small"
                checked={verification}
                onChange={handleChange}
              />
            </div>
            {loading && (
              <span className="text-[10px] text-center">Loading...</span>
            )}
          </div>

          {/* Avatar */}
          <Avatar src={logo} className="!bg-gray-400 h-8 w-8 md:h-10 md:w-10" />

          {/* Username (hide on mobile) */}
          <p className="hidden md:block font-semibold capitalize">
            {user_name}
          </p>

          {/* Logout */}
          <Button
            onClick={handleLogoutReseller}
            variant="contained"
            size="small"
            className="!bg-red-500 !capitalize text-white"
          >
            Log Out
          </Button>
        </div>
      </div>

      {/* Mobile Two Step Toggle */}
      <div className="flex sm:hidden justify-between items-center mt-2 px-2">
        <span className="text-xs">Two-Step Verification</span>
        <Switch size="small" checked={verification} onChange={handleChange} />
      </div>
    </header>
  );
};

export default Header;
